import styled from 'styled-components';
import { colors } from 'stylesheets';

export const Paginate = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const List = styled.ul`
  list-style-type: none;
  display: inline-flex;
`;

export const ListItem = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${({ ellipsis }) => (ellipsis ? 'not-allowed' : 'pointer')};

  width: 30px;
  height: 30px;
  margin: 5px;
  background: ${colors.white};
  border: 1px solid ${colors.greyMedium};
  box-sizing: border-box;
  border-radius: 3px;

  font-size: 14px;
  color: ${({ active }) => (active ? colors.greyDark : colors.greyMedium)};
  box-shadow: ${({ active }) => (active ? 'inset 0px 2px 4px rgba(0, 0, 0, 0.25)' : 'none')};
`;
